import React from 'react';
import PropTypes from 'prop-types';
import './container.scss';
import { getClassNames } from '../../../ExportUtils';

const config = {
  size: {
    xxs: 'container--xxs',
    xs: 'container--xs',
    sm: 'container--sm',
    md: 'container--md',
    lg: 'container--lg',
    xl: 'container--xl',
    fluid: 'container--fluid'
  }
};

const Container = ({ className = '', children, size = '', ...other }) => {
  const classes = ['container', className, config.size[size]];
  return (
    <div className={getClassNames(classes)} {...other}>
      {children}
    </div>
  );
};

Container.propTypes = {
  size: PropTypes.oneOf(Object.keys(config.size))
};

export default Container;
